export default function Footer() {
  return (
    <footer className="bg-kura-dark py-12">
      <div className="max-w-6xl mx-auto px-6">
        {/* Top ainu border */}
        <div className="ainu-border mb-10 opacity-60" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div>
                <p
                  className="text-kura-gold text-xs tracking-widest"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  蔵合同会社
                </p>
              </div>
            </div>
            <p
              className="text-white/50 text-xs leading-relaxed tracking-wide"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              「どんなものにも、価値がある。」
              <br />
              北海道を拠点に、催事・出張買取専門で活動しています。
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-kura-gold text-xs tracking-widest uppercase mb-4"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              メニュー
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: '私たちについて', href: '#about' },
                { label: '取扱品目', href: '#items' },
                { label: '買取の流れ', href: '#process' },
                { label: 'お問い合わせ', href: '#contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(link.href);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-white/50 hover:text-kura-gold-light text-xs tracking-wide cursor-pointer transition-colors duration-200"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="text-kura-gold text-xs tracking-widest uppercase mb-4"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              お問い合わせ先
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-kura-gold text-base" />
                </div>
                <div>
                  <p
                    className="text-white/30 text-xs tracking-wide mb-0.5"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    電話番号
                  </p>
                  <a
                    href="tel:05054827440"
                    className="text-white/80 hover:text-kura-gold-light text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    050-5482-7440
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-kura-gold text-base" />
                </div>
                <div>
                  <p
                    className="text-white/30 text-xs tracking-wide mb-0.5"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    メールアドレス
                  </p>
                  <a
                    href="mailto:info@kaitori-konkane.jp"
                    className="text-white/80 hover:text-kura-gold-light text-xs tracking-wide transition-colors duration-200 cursor-pointer break-all"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    info@kaitori-konkane.jp
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* License Info */}
          <div>
            <h4
              className="text-kura-gold text-xs tracking-widest uppercase mb-4"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              会社情報・許認可
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: '会社名', value: '蔵合同会社' },
                { label: '屋号', value: '買取こんかね' },
                { label: '住所', value: '北海道虻田郡ニセコ町近藤741-35' },
                { label: '営業形態', value: '催事・出張買取専門' },
                { label: '古物商許可番号', value: '第101190000218号' },
                { label: '管轄警察署', value: '倶知安警察署' },
              ].map((item) => (
                <li key={item.label} className="flex items-start gap-2">
                  <span
                    className="text-white/30 text-xs w-28 flex-shrink-0 tracking-wide"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {item.label}
                  </span>
                  <span
                    className="text-white/70 text-xs tracking-wide"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {item.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom ainu border */}
        <div className="ainu-border mb-6 opacity-40" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p
            className="text-white/30 text-xs tracking-wide"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            &copy; {new Date().getFullYear()} 蔵合同会社 買取こんかね All Rights Reserved.
          </p>
          <p
            className="text-white/20 text-xs tracking-wide"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            「こんかね」とはアイヌ語で「黄金」を意味します
          </p>
        </div>
      </div>
    </footer>
  );
}
